// marketplace/ProductCard.jsx
// Single product card used inside ProductGrid.
// Clicking navigates to /#/:storeSlug/:productSlug

import React from "react";
import { Link } from "react-router-dom";
import { Package } from "lucide-react";
import { brand } from "../shared/brand";

export function ProductCard({ product }) {
  const { title, price, primary_image, badge, seller, product_slug, sku } = product;

  // Build URL: /storeSlug/productSlug
  const storeSlug = seller?.store_slug || seller?.username;
  const to        = `/${storeSlug}/${product_slug || sku}`;

  // Badge color: green for same-day provider, gold for regular, hidden for tomorrow
  const showBadge = badge && badge.type !== "manana";
  const badgeBg   = badge?.type === "hoy_provider" ? brand.accentGreen : brand.accentGold;

  return (
    <Link
      to={to}
      className="group flex flex-col rounded-2xl bg-white border border-slate-100 overflow-hidden shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
    >
      {/* Image */}
      <div className="relative aspect-square bg-slate-100 overflow-hidden">
        {primary_image ? (
          <img
            src={primary_image}
            alt={title}
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300"
            loading="lazy"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center">
            <Package className="size-10 text-slate-300" />
          </div>
        )}

        {showBadge && (
          <div
            className="absolute top-2 left-2 rounded-lg px-2 py-0.5 text-[10px] font-bold text-white shadow"
            style={{ background: badgeBg }}
          >
            {badge.label}
          </div>
        )}
      </div>

      {/* Info */}
      <div className="p-2.5 flex flex-col gap-0.5">
        <p className="text-[11px] text-slate-400 truncate">{seller?.username}</p>
        <p className="text-sm font-semibold text-slate-800 leading-tight line-clamp-2">{title}</p>
        <p className="text-sm font-extrabold mt-1" style={{ color: brand.primary }}>
          S/ {parseFloat(price).toFixed(2)}
        </p>
      </div>
    </Link>
  );
}